export const CYCLE_TYPES = {
  REQUIRED: 'Required',
  OPTIONAL: 'Optional'
};
